<script>
    import Engine from "../../../mixins/Engine";
    import {Listeners} from "../../../constants/listeners";

    export default {
        mixins: [Engine],
        data() {
            return {
                values: {
                    sr: this.isGoogleNY() ? [{value: 0, label: this.$t('lang.main.table.sr2')}, {value: 1, label: this.$t('lang.main.table.sr3')}] : [{value: 0, label: this.$t('lang.main.table.sr0')}, {value: 1, label: this.$t('lang.main.table.sr1')}],
                    boolean: [{value: true, label: this.$t('lang.main.table.yes')}, {value: false, label: this.$t('lang.main.table.no')}],
                    bool: [{value: 1, label: this.$t('lang.main.table.yes')}, {value: 0, label: this.$t('lang.main.table.no')}],
                    competition: [{value: 1, label: this.$t('lang.main.table.competition.1')}, {value: 2, label: this.$t('lang.main.table.competition.2')}, {value: 3, label: this.$t('lang.main.table.competition.3')}],
                    link_type: [{value: 0, label: this.$t('lang.report.backlinks.linkTypes.0')}, {value: 1, label: this.$t('lang.report.backlinks.linkTypes.1')}, {value: 2, label: this.$t('lang.report.backlinks.linkTypes.2')}, {value: 3, label: this.$t('lang.report.backlinks.linkTypes.3')}],
                    link_status: [{value: 1, label: this.$t('lang.report.backlinks.linkStatus.1')}, {value: 10, label: this.$t('lang.report.backlinks.linkStatus.10')}],
                    link_statuses: [{value: 1, label: this.$t('lang.report.backlinks.linkStatus.1')}, {value: 10, label: this.$t('lang.report.backlinks.linkStatus.10')}],
                }
            }
        },
        props: {
            item:{
                type: Object,
                required: true

            },
        },
        methods: {
            submitFormFilter(){
                this.$emitter.emit(Listeners.KS_FILTER_SUBMIT_FORM);
            }
        },
    }
</script>
<template>
    <select class="fieldselect" v-model="item.value">
        <option v-for="v in values[item.type]" v-bind:value="v.value" v-text="v.label"></option>
    </select>
</template>

